export enum SortDirectionEnum {
  Ascending = "asc",
  Descending = "desc",
}
